import Banner from '@/components/Banner';
import ImageGallery from '@/components/ImageGallery';
import { Reveal, RevealGroup, RevealItem } from '@/components/Reveal';
import ShareDialog from '@/components/ShareDialog';
import Typography from '@/components/ui/typography';
import Band from '@/Layouts/Band';
import SectionLayout from '@/Layouts/SectionLayout';

const LifetimeAchievement = ({ images }: { images: string[] }) => {
  const urls = images.map((image) => `/storage/${image}`);
  const galleryImages = urls.slice(2);

  return (
    <>
      <Banner
        image={urls[0]}
        alt="Rtn Thamizhachi Priya Govindaraj receiving the Lifetime Achievement award"
        tagline="Extraordinary recognition"
        title="Lifetime Achievement"
        description="Rtn Thamizhachi Priya Govindaraj has been bestowed with the prestigious Best Trainer, Choreographer and Costume Designer awards, for the training provided at Samuthrika Academy to the NCC cadets of Tamil Nadu, Pondicherry, and the Andaman & Nicobar directorates."
      >
        <ShareDialog
          url={window.location.href}
          title="Rtn Thamizhachi Priya Govindaraj's Lifetime Achievement"
          content="In a momentous accolade, Rtn Thamizhachi Priya Govindaraj has been bestowed with the prestigious Best Trainer/Choreographer/Costume Designer Awards. Her exceptional expertise shone brightly through the training provided at Samuthrika Academy to the NCC Cadets of Tamilnadu, Pondicherry, and Andaman & Nicobar Directorates."
        />
      </Banner>

      {/* One content block, so no spine here — a rail with a single stop reads
          as a rendering fault rather than as a sequence. */}
      <Band tone="indigo" pattern="stitch" patternOpacity="medium">
        <SectionLayout width="prose" space="lg">
          <Reveal className="flex flex-col gap-4">
            <Typography.Eyebrow>New Delhi, January 2016</Typography.Eyebrow>
            <Typography.Display2 className="text-2xl md:text-3xl lg:text-4xl">
              National Integration Awareness Programme
            </Typography.Display2>
            <Typography.Body className="text-indigo-foreground/85">
              A significant component of the Republic Day celebrations and the
              Prime Minister&apos;s NCC Rally.
            </Typography.Body>
          </Reveal>
        </SectionLayout>
      </Band>

      <Band tone="raised" pattern="lattice">
        <SectionLayout space="lg">
          <RevealGroup className="grid items-center gap-8 md:grid-cols-2 md:gap-12">
            {urls[1] && (
              <RevealItem className="md:order-2">
                <div className="aspect-4/3 overflow-hidden rounded-xl bg-muted shadow-card">
                  <img
                    className="size-full object-cover"
                    src={urls[1]}
                    alt=""
                    loading="lazy"
                  />
                </div>
              </RevealItem>
            )}

            <RevealItem className="flex flex-col items-start gap-3">
              <Typography.Eyebrow>Third of seventeen</Typography.Eyebrow>
              <Typography.Display3 className="text-2xl md:text-3xl lg:text-4xl">
                A winning streak unseen since 2004
              </Typography.Display3>
              <Typography.Body className="max-w-prose text-muted-foreground">
                Elevating the cadets to a commendable{' '}
                <span className="font-semibold text-primary">
                  third position
                </span>{' '}
                among the 17 directorates nationwide, Rtn Thamizhachi Priya
                Govindaraj&apos;s training prowess ignited a winning streak not
                witnessed since 2004. Her contribution was acknowledged with a
                Certificate of Appreciation, presented by Commodore Vijesh K
                Garg, Deputy Director General of the NCC Directorate, and
                Colonel KB Jairaj, Group Commander, NCC GP HQ Tiruchirapalli.
              </Typography.Body>
            </RevealItem>
          </RevealGroup>
        </SectionLayout>
      </Band>

      {galleryImages.length > 0 && (
        <Band tone="raised" seam>
          <SectionLayout space="lg">
            <Reveal className="flex flex-col gap-3">
              <Typography.Eyebrow>From the rally</Typography.Eyebrow>
              <Typography.Display2 className="text-2xl md:text-3xl lg:text-4xl">
                Photographs
              </Typography.Display2>
            </Reveal>

            <ImageGallery
              images={galleryImages}
              alt="Photographs from the NCC rally and award ceremony"
            />
          </SectionLayout>
        </Band>
      )}
    </>
  );
};

export default LifetimeAchievement;
